import { TipCategory } from './MyWaysToSave';
import HandAndMoneyIcon from '../../static/HandAndMoney.svg';

export const RES_TIP_CATEGORIES: TipCategory[] = [
  {
    titleKey: 'WTS_HEATING_AND_COOLING',
    tips: [
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'PRACTICE_THERMOSTAT_CONTROL',
        detailsKey: 'PRACTICE_THERMOSTAT_CONTROL_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'UPGRADE_TO_A_SMART_THERMOSTAT',
        detailsKey: 'UPGRADE_TO_A_SMART_THERMOSTAT_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'USE_FANS_TO_STAY_COMFORTABLE',
        detailsKey: 'USE_FANS_TO_STAY_COMFORTABLE_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'RUN_CEILING_FANS_IN_REVERSE_DURING_WINTER',
        detailsKey: 'RUN_CEILING_FANS_IN_REVERSE_DURING_WINTER_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'DONT_HEAT_OR_COOL_UNUSED_ROOMS',
        detailsKey: 'DONT_HEAT_OR_COOL_UNUSED_ROOMS_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'REPLACE_AIR_FILTERS_REGULARLY',
        detailsKey: 'REPLACE_AIR_FILTERS_REGULARLY_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'SCHEDULE_ANNUAL_HVAC_MAINTENANCE',
        detailsKey: 'SCHEDULE_ANNUAL_HVAC_MAINTENANCE_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'KEEP_VENTS_CLEAR',
        detailsKey: 'KEEP_VENTS_CLEAR_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'CLEAR_DEBRIS_AROUND_OUTDOOR_EQUIPMENT',
        detailsKey: 'CLEAR_DEBRIS_AROUND_OUTDOOR_EQUIPMENT_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'CONSIDER_A_WHOLE_HOUSE_FAN',
        detailsKey: 'CONSIDER_A_WHOLE_HOUSE_FAN_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'UPGRADE_TO_AN_EFFICIENT_HEAT_PUMP',
        detailsKey: 'UPGRADE_TO_AN_EFFICIENT_HEAT_PUMP_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'CONSIDER_DUCTLESS_HEATING_AND_COOLING',
        detailsKey: 'CONSIDER_DUCTLESS_HEATING_AND_COOLING_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'UPGRADE_AN_OLDER_ROOM_AIR_CONDITIONER',
        detailsKey: 'UPGRADE_AN_OLDER_ROOM_AIR_CONDITIONER_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'UPGRADE_YOUR_HEATING_SYSTEM',
        detailsKey: 'UPGRADE_YOUR_HEATING_SYSTEM_DETAILS',
        renterFriendly: false,
      },
    ],
  },
  {
    titleKey: 'WTS_WEATHERIZATION_AND_INSULATION',
    tips: [
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'SEAL_AIR_LEAKS',
        detailsKey: 'SEAL_AIR_LEAKS_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'IMPROVE_INSULATION',
        detailsKey: 'IMPROVE_INSULATION_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'UPGRADE_TO_ENERGY_EFFICIENT_WINDOWS',
        detailsKey: 'UPGRADE_TO_ENERGY_EFFICIENT_WINDOWS_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'SEAL_DUCT_LEAKS',
        detailsKey: 'SEAL_DUCT_LEAKS_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'ADD_FOAM_OUTLET_AND_SWITCH_COVERS',
        detailsKey: 'ADD_FOAM_OUTLET_AND_SWITCH_COVERS_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'REDUCE_FIREPLACE_DRAFTS',
        detailsKey: 'REDUCE_FIREPLACE_DRAFTS_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'BLOCK_DRAFTS_AROUND_DOORS',
        detailsKey: 'BLOCK_DRAFTS_AROUND_DOORS_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'INSTALL_SOLAR_SCREENS_OR_WINDOW_FILM',
        detailsKey: 'INSTALL_SOLAR_SCREENS_OR_WINDOW_FILM_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'CONSIDER_A_RADIANT_BARRIER',
        detailsKey: 'CONSIDER_A_RADIANT_BARRIER_DETAILS',
        renterFriendly: false,
      },
    ],
  },
  {
    titleKey: 'WTS_APPLIANCES_AND_ELECTRONICS',
    tips: [
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'REDUCE_STANDBY_ENERGY_USE_WITH_SMART_POWER_STRIPS',
        detailsKey: 'REDUCE_STANDBY_ENERGY_USE_WITH_SMART_POWER_STRIPS_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'USE_SLEEP_MODE_ON_COMPUTERS',
        detailsKey: 'USE_SLEEP_MODE_ON_COMPUTERS_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'UNDERSTAND_YOUR_HOMES_ENERGY_USE',
        detailsKey: 'UNDERSTAND_YOUR_HOMES_ENERGY_USE_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'COMPLETE_AN_ONLINE_HOME_ENERGY_ASSESSMENT',
        detailsKey: 'COMPLETE_AN_ONLINE_HOME_ENERGY_ASSESSMENT_DETAILS',
        renterFriendly: false,
      },
    ],
  },
  {
    titleKey: 'WTS_LIGHTING',
    tips: [
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'REPLACE_OLDER_BULBS_WITH_LEDS',
        detailsKey: 'REPLACE_OLDER_BULBS_WITH_LEDS_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'USE_TASK_LIGHTING',
        detailsKey: 'USE_TASK_LIGHTING_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'USE_NATURAL_DAYLIGHT',
        detailsKey: 'USE_NATURAL_DAYLIGHT_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'INSTALL_DIMMERS_TIMERS_AND_SENSORS',
        detailsKey: 'INSTALL_DIMMERS_TIMERS_AND_SENSORS_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'TURN_OFF_LIGHTS_WHEN_LEAVING_A_ROOM',
        detailsKey: 'TURN_OFF_LIGHTS_WHEN_LEAVING_A_ROOM_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'CHOOSE_ENERGY_EFFICIENT_LIGHT_FIXTURES',
        detailsKey: 'CHOOSE_ENERGY_EFFICIENT_LIGHT_FIXTURES_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'USE_SOLAR_OUTDOOR_LIGHTING',
        detailsKey: 'USE_SOLAR_OUTDOOR_LIGHTING_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'CHOOSE_LED_HOLIDAY_LIGHTS',
        detailsKey: 'CHOOSE_LED_HOLIDAY_LIGHTS_DETAILS',
        renterFriendly: true,
      },
    ],
  },
  {
    titleKey: 'WTS_KITCHEN_AND_REFRIGERATION',
    tips: [
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'CLEAN_REFRIGERATOR_COILS',
        detailsKey: 'CLEAN_REFRIGERATOR_COILS_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'KEEP_YOUR_FREEZER_FULL',
        detailsKey: 'KEEP_YOUR_FREEZER_FULL_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'UNPLUG_A_SECOND_REFRIGERATOR_OR_FREEZER',
        detailsKey: 'UNPLUG_A_SECOND_REFRIGERATOR_OR_FREEZER_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'COOK_WITH_SMALLER_APPLIANCES',
        detailsKey: 'COOK_WITH_SMALLER_APPLIANCES_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'USE_LIDS_WHEN_COOKING',
        detailsKey: 'USE_LIDS_WHEN_COOKING_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'COOK_MULTIPLE_DISHES_AT_ONCE',
        detailsKey: 'COOK_MULTIPLE_DISHES_AT_ONCE_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'COOK_LARGER_BATCHES',
        detailsKey: 'COOK_LARGER_BATCHES_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'CHOOSE_EFFICIENT_COOKING_APPLIANCES',
        detailsKey: 'CHOOSE_EFFICIENT_COOKING_APPLIANCES_DETAILS',
        renterFriendly: false,
      },
    ],
  },
  {
    titleKey: 'WTS_LAUNDRY_AND_DISHWASHING',
    tips: [
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'WASH_CLOTHES_IN_COLD_WATER',
        detailsKey: 'WASH_CLOTHES_IN_COLD_WATER_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'USE_ENERGY_SAVING_WASHER_SETTINGS',
        detailsKey: 'USE_ENERGY_SAVING_WASHER_SETTINGS_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'AIR_DRY_WHEN_POSSIBLE',
        detailsKey: 'AIR_DRY_WHEN_POSSIBLE_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'USE_YOUR_DRYERS_MOISTURE_SENSOR',
        detailsKey: 'USE_YOUR_DRYERS_MOISTURE_SENSOR_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'RUN_FULL_LOADS',
        detailsKey: 'RUN_FULL_LOADS_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'USE_DISHWASHER_EFFICIENCY_SETTINGS',
        detailsKey: 'USE_DISHWASHER_EFFICIENCY_SETTINGS_DETAILS',
        renterFriendly: true,
      },
    ],
  },
  {
    titleKey: 'WTS_WATER_HEATING',
    tips: [
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'SET_YOUR_WATER_HEATER_TO_120F',
        detailsKey: 'SET_YOUR_WATER_HEATER_TO_120F_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'INSULATE_HOT_WATER_PIPES',
        detailsKey: 'INSULATE_HOT_WATER_PIPES_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'INSTALL_LOW_FLOW_FAUCET_AERATORS',
        detailsKey: 'INSTALL_LOW_FLOW_FAUCET_AERATORS_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'UPGRADE_TO_AN_EFFICIENT_WATER_HEATER',
        detailsKey: 'UPGRADE_TO_AN_EFFICIENT_WATER_HEATER_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'CONSIDER_A_HEAT_PUMP_WATER_HEATER',
        detailsKey: 'CONSIDER_A_HEAT_PUMP_WATER_HEATER_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'USE_A_WATER_HEATER_TIMER',
        detailsKey: 'USE_A_WATER_HEATER_TIMER_DETAILS',
        renterFriendly: false,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'LOWER_WATER_HEATER_SETTINGS_WHEN_AWAY',
        detailsKey: 'LOWER_WATER_HEATER_SETTINGS_WHEN_AWAY_DETAILS',
        renterFriendly: false,
      },
    ],
  },
  {
    titleKey: 'WTS_ENERGY_SAVING_HABITS',
    tips: [
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'TURN_OFF_BATHROOM_VENTILATION_FANS',
        detailsKey: 'TURN_OFF_BATHROOM_VENTILATION_FANS_DETAILS',
        renterFriendly: true,
      },
      {
        Icon: HandAndMoneyIcon,
        titleKey: 'CREATE_A_HOUSEHOLD_ENERGY_SAVING_PLAN',
        detailsKey: 'CREATE_A_HOUSEHOLD_ENERGY_SAVING_PLAN_DETAILS',
        renterFriendly: true,
      },
    ],
  },
];
